/**
 * DataLabel objects represent the label applied per section
 * The label can have multi line text spans
 * @class DataLabel
 */
export default class DataLabel {
  /**
   * When constructing a DataLabel object, you can pass in a more complex object
   * only the properties defined on the LabelData prototype will be cherry picked
   *
   * ```javascript
   * opts = {
   *   id: '123456',
   *   angle: 45,
   *   text: [
   *     'line 1',
   *     'line 2'
   *   ],
   *   font: 'arial',
   *   scale: 10,
   *   size: 10,
   *   position: {
   *     x: 10,
   *     y: 20
   *   }
   * };
   * ```
   * @param {Object} opts
   */
  constructor (opts) {
    opts = opts || {};

    /** @type {String|null} */
    this.id = opts.id;

    /**
     * Define here the text for your label. One string per line.
     * each line will be wrapped in a <tspan> tag. Consider that <tspan> elements do not accept multiple spaces.
     * If you need to "hackily" space your labels around use the unicode character "\u00a0".
     *
     * ```javascript
     * opts.text = [
     *   'first line',
     *   '\u00a0\u00a0\u00a0\u00a0\u00a0hacked second line'
     * ];
     * ```
     * @type {Array<String>} */
    this.text = opts.text;

    /**
     * Define in degrees how much the label needs to rotate around its "position" point
     * @type {Number}
     */
    this.angle = opts.angle;

    /**
     * Specify the fontSize for your label
     * this will appear on the tspan element
     *
     * ```SVG
     * <text>
     *   <tspan fontSize="12">some text</tspan>
     * </text>
     * ```
     *
     * @type {Number}
     */
    this.fontSize = opts.fontSize;


    /**
     * Specify the fontWeight for your label
     * this will appear on the tspan element
     *
     *
     * @type {String}
     */
    this.fontWeight = opts.fontWeight;

    /**
     * This is a spatial point where your label will be anchored
     * @type {DataPoint}
     */
    this.position = opts.position;


    /**
     * This is a spatial point where your label will rotate.
     * Giving you the possibility of rotating in a different position than the label x,y
     * @type {DataPoint}
     */
    this.rotationPosition = opts.rotationPosition || opts.position;
  }
}



// WEBPACK FOOTER //
// ./frontend/react/sim/schemas/Label.js